var staticHGKeyRE = /(.+)?\[(\d+)\]$/

module.exports = staticHGKeyRE



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticHGKeyRE.js
// module id = 536
// module chunks = 75